import { takeLatest, call, put, all } from 'redux-saga/effects';

import {
  getUserAddress,
  addUserAddress,
  searchProducts,
  submitOrderBulk,
  uploadOrderAttachments,
} from './api';
import {
  fetchGetUserAddressSuccess,
  fetchGetUserAddressFail,
  fetchAddUserAddressSuccess,
  fetchAddUserAddressFail,
  fetchSearchProductsSuccess,
  fetchSearchProductsFail,
  fetchSubmitOrderBulkSuccess,
  fetchSubmitOrderBulkFail,
} from './actions';
import orderActionTypes from './action-types';

function* fetchGetUserAddressSaga({ payload }) {
  const { callbackActionSuccess } = payload;

  try {
    const response = yield call(getUserAddress, payload);
    yield put(fetchGetUserAddressSuccess(response.data));

    if (response.data.length === 0) callbackActionSuccess();
  } catch (error) {
    yield put(fetchGetUserAddressFail(error));
  }
}

function* fetchAddUserAddressSaga({ payload }) {
  const { callbackActionSuccess } = payload;

  try {
    const response = yield call(addUserAddress, payload);
    yield put(fetchAddUserAddressSuccess(response.data));

    callbackActionSuccess();
  } catch (error) {
    yield put(fetchAddUserAddressFail(error));
  }
}

function* fetchSearchProductsSaga({ payload }) {
  try {
    const response = yield call(searchProducts, payload);
    yield put(fetchSearchProductsSuccess(response.data));
  } catch (error) {
    yield put(fetchSearchProductsFail(error));
  }
}

function* fetchSubmitOrderBulkSaga({ payload }) {
  try {
    const delay = ms =>
      new Promise(res => {
        setTimeout(res, ms);
      });

    const { headers, data, ordersFiles, bulkOrderConfigurations } = payload;
    const { orderChunkSizeValue, orderPauseTimeValue } = bulkOrderConfigurations;
    const ordersData = [...data];
    const fileUploadApiCalls = [];

    ordersFiles.forEach(order => {
      const formData = new FormData();
      formData.append('file', order.fileData);
      formData.append('location', 'CartAttachment');
      formData.append('isCartAttachment', true);

      fileUploadApiCalls.push(call(uploadOrderAttachments, { data: formData }));
    });

    const fileUploadResponse = yield all(fileUploadApiCalls);
    fileUploadResponse.forEach((item, index) => {
      const fileObj = ordersFiles[index];

      ordersData[fileObj.index].orderAttachments[fileObj.detailsIndex].url = item.data.url;
    });

    let response = [];
    for (let i = 0; i < ordersData.length; i += orderChunkSizeValue) {
      const chunk = ordersData.slice(i, i + orderChunkSizeValue);
      const chunkResponse = yield call(submitOrderBulk, { headers, data: chunk });
      response = [...response, ...chunkResponse.data];
      yield call(delay, orderPauseTimeValue);
    }

    yield put(fetchSubmitOrderBulkSuccess(response));
  } catch (error) {
    yield put(fetchSubmitOrderBulkFail(error));
  }
}

function* orderSaga() {
  yield takeLatest(orderActionTypes.FETCH_GET_USER_ADDRESS, fetchGetUserAddressSaga);
  yield takeLatest(orderActionTypes.FETCH_ADD_USER_ADDRESS, fetchAddUserAddressSaga);
  yield takeLatest(orderActionTypes.FETCH_SEARCH_PRODUCTS, fetchSearchProductsSaga);
  yield takeLatest(orderActionTypes.FETCH_SUBMIT_ORDER_BULK, fetchSubmitOrderBulkSaga);
}

export default orderSaga;
